// RFC 9562 UUIDv7 generator (time-ordered, 48-bit unix-ms timestamp + random bits).
// Own implementation because the bundled uuid@8.3.2 has no v7 and newer uuid
// versions (11+) ship browser ESM builds that webpack 4 cannot parse.
// Used for OT-attribute dirty bits in the BCD editor bundled JSON template.
function uuid7() {
  const bytes = new Uint8Array(16)
  let ts = Date.now()
  for (let i = 5; i >= 0; i--) {
    bytes[i] = ts & 0xff
    ts = Math.floor(ts / 0x100)
  }
  const rand = window.crypto.getRandomValues(new Uint8Array(10))
  rand[0] = (rand[0] & 0x0f) | 0x70
  rand[2] = (rand[2] & 0x3f) | 0x80
  bytes.set(rand, 6)
  const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export default uuid7
